import React, { useEffect, useState } from 'react';
import CommonModalLayout from '../Layouts/CommonModalLayout';
import { buttonStyles, inputStyles } from '../../styles/commonStyles';
import { useTranslation } from 'react-i18next';
import { updateCategory, getCategoryGroupsByUserId } from '../../api/categories';
import { useSelector } from 'react-redux';
import { useQueryClient, useQuery } from 'react-query';
import { Select } from '../ui/select';

const EditCategoryModal = ({ isOpen, onClose, category }) => {
    const { t } = useTranslation();
    const [categoryName, setCategoryName] = useState('');
    const [selectedGroup, setSelectedGroup] = useState('none');
    const queryClient = useQueryClient();
    const userId = useSelector(state => state.auth.user?.id);

    // Получаем группы пользователя
    const { data: groupsData } = useQuery(
        ['categoryGroups', userId],
        () => getCategoryGroupsByUserId(userId),
        { enabled: !!userId }
    );
    const groupOptions = [
        { value: 'none', label: t('categories.withoutGroup', 'Без группы') },
        ...(groupsData ? groupsData.map(group => ({ value: String(group.id), label: group.name })) : [])
    ];

    // При открытии модалки подгружаем данные категории
    useEffect(() => {
        if (category) {
            setCategoryName(category.name || '');
            setSelectedGroup(category.group_id ? String(category.group_id) : 'none');
        }
    }, [category, isOpen]);

    const handleUpdate = async () => {
        try {
            const groupIdToSend = selectedGroup === 'none' ? null : selectedGroup;
            await updateCategory(category.id, { name: categoryName, group_id: groupIdToSend });
            queryClient.invalidateQueries(['categories', userId]);
            queryClient.invalidateQueries(['groupedCategories', userId]);
            onClose();
        } catch (error) {
            console.error('Error updating category:', error);
            alert(`Error: ${error.message}`);
        }
    };

    return (
        <CommonModalLayout
            isOpen={isOpen}
            onClose={onClose}
            title={t('categories.edit', 'Редактировать категорию')}
        >
            <div className="space-y-4">
                <div className="space-y-2">
                    <label htmlFor="categoryName" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        {t('categories.name')}
                    </label>
                    <input
                        type="text"
                        id="categoryName"
                        value={categoryName}
                        onChange={(e) => setCategoryName(e.target.value)}
                        className={inputStyles}
                        placeholder={t('categories.namePlaceholder')}
                    />
                </div>
                <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        {t('categories.group', 'Группа')}
                    </label>
                    <Select
                        options={groupOptions}
                        value={selectedGroup}
                        onValueChange={setSelectedGroup}
                        className={inputStyles}
                        placeholder={t('categories.selectGroup', 'Без группы')}
                    />
                </div>
                <div className="flex justify-end space-x-2">
                    <button
                        onClick={onClose}
                        className={buttonStyles}
                    >
                        {t('common.cancel')}
                    </button>
                    <button
                        onClick={handleUpdate}
                        className={buttonStyles}
                        disabled={!categoryName.trim()}
                    >
                        {t('common.save', 'Сохранить')}
                    </button>
                </div>
            </div>
        </CommonModalLayout>
    );
};

export default EditCategoryModal; 